import React, { Fragment } from 'react';

import { Card, Skeleton, Space, Switch, Typography } from 'antd';
import useApp from 'antd/es/app/useApp';

import { useAccount } from 'lib/providers/AccountContextProvider';
import { updateAccount } from 'services/Account.service';

export function SettingsConfig() {
    const app = useApp();
    
    const { clientManager, isLoading, fetchClientManager, setIsLoading} = useAccount();

    const updateClientManager = async (field: string, value: boolean) => {
        setIsLoading(true);

        const response = await updateAccount({ [field]: value });
        
        if (!response.success)
            return app.message.error('Erro ao atualizar configuração');

        await fetchClientManager();

        app.message.success('Configuração atualizada com sucesso');
    };

    if (isLoading)
        return (<Card>
            <Skeleton active />
        </Card>);

    return (
        <Fragment>
            <Card title="Chamados" styles={{ body: { paddingTop: 0 } }}>
                <Space direction='vertical'>
                    <Space size='middle' direction='horizontal' style={{ alignItems: 'end' }}>
                        <Typography.Title level={5} style={{ marginBottom: 0 }}>Habilitar ordenação por prioridade</Typography.Title>
                        <Switch
                            onChange={(checked) => updateClientManager('config_issue_enable_priority_sorting', checked)}
                            checked={clientManager?.config_issue_enable_priority_sorting} />
                    </Space>
                    <Typography.Text type="secondary">
                        Ativar esta opção permite que os chamados sejam ordenados por prioridade, facilitando a gestão de atendimentos urgentes. Serão considerados os chamados que possuem no assunto a palavra "urgente".
                    </Typography.Text>
                </Space>

                <Space direction='vertical'>
                    <Space size='middle' direction='horizontal' style={{ alignItems: 'end' }}>
                        <Typography.Title level={5} style={{ marginBottom: 0 }}>Habilitar ordenação por criação</Typography.Title>
                        <Switch
                            onChange={(checked) => updateClientManager('config_issue_enable_creation_sorting', checked)}
                            checked={clientManager?.config_issue_enable_creation_sorting} />
                    </Space>
                    <Typography.Text type="secondary">
                        Ativar esta opção permite que os chamados sejam ordenados pela data de criação, facilitando a visualização dos chamados mais recentes.
                    </Typography.Text>
                </Space>
            </Card>

        </Fragment>
    );
}
